import ApiCommon from "api/ApiCommon";

export type ActiveGrzResp = {
  result?: {
    ok?: boolean;
    data?: string[];
    error?: string | null;
  };
  errorMessage?: string;
};

const activeGrzCache = new Map<string, Promise<string[]>>();

const normalizeActiveGrzResponse = (data: ActiveGrzResp): string[] => {
  if (!data?.result?.ok || !Array.isArray(data.result.data)) return [];
  return data.result.data.filter((item): item is string => typeof item === 'string');
};

export function getActiveGrz(zone: string | undefined): Promise<string[]> {
  return ApiCommon.post('/grzs_in_parking', zone, {}).then(normalizeActiveGrzResponse);
}

export function prefetchActiveGrz(zone: string | undefined): Promise<string[]> {
  const cacheKey = zone ?? '';
  const cached = activeGrzCache.get(cacheKey);
  if (cached) return cached;

  const request = getActiveGrz(zone).catch(() => []);
  activeGrzCache.set(cacheKey, request);
  return request;
}
